import {
  Button, Card, CardContent, CardHeader, Divider, Typography, DialogContent, Dialog, IconButton, DialogActions
} from '@material-ui/core';
import MonochromePhotosIcon from '@material-ui/icons/MonochromePhotos';
import { makeStyles } from '@material-ui/styles';
import axios from 'src/utils/axios';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect, useSelector } from 'react-redux';
import { loadBaslandiJob, saveBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import NextWeekIcon from '@material-ui/icons/NextWeek';
import CCFilePopup from '../../components/CCFilePopup';
import AppReasonSearch from '../../components/Selects/AppReasonSearch';
import { setTask } from '../../store/actions/taskActions';
import GdprPopup from '../../components/GdprPopup';
import NewWorkCasePopup from '../../components/NewWorkCasePopup';
import Moment from 'moment';
import { getUser } from 'src/utils/Common';
import Compensation from 'src/views/WorkOrder/CompensationForm';
import ListAltIcon from '@material-ui/icons/ListAlt';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles(() => ({
  root: {},
  content: {
    minHeight: 430,
  },
  submitButtonFile: {
    width: '100%'
  }
}));


function Aciklama({
  className, ReceiptNo, readonly, tasks, setTask
}) {
  const classes = useStyles();
  const { t } = useTranslation('work_order');
  const [data, setData] = useState({});
  const [CCFilePopupOpen, setCCFilePopupOpen] = React.useState(false);
  const [GdprPopupOpen, setGdprPopupOpen] = useState(false);
  const [NewWorkCasePopupOpen, setNewWorkCasePopupOpen] = useState(false);
  const [CompensationPopup, setCompensationPopup] = React.useState(false);
  const [newAppointmentDate, setNewAppointmentDate] = useState('');

  const isOnline = useSelector((state) => state.status?.isOnline);


  const SessionUser = getUser();
  Moment.locale(SessionUser.TenantCode === 'my' ? 'en' : SessionUser.TenantCode);
  const handleCCFileClose = () => {
    setCCFilePopupOpen(false);
  };
  const handleGdprPopupClose = () => {
    setGdprPopupOpen(false);
  };
  const handleNewWorkCasePopupClose = () => {
    setNewWorkCasePopupOpen(false);
  };

  useEffect(() => {
    const storeData = readonly ? tasks.tasks.filter((d) => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)) : loadBaslandiJob();
    setData(storeData[0]);
  }, [ReceiptNo, tasks.tasks, readonly]);

  const search = '';


  const setIssue = (param) => {
    if (readonly) {
      return;
    }
    let job = loadBaslandiJob()[0];
    job = {
      ...job,
      IssueReason: param.Dsc,
      IssueReasonId: param.Id,
    };
    saveBaslandiJob(job);
    setData(job);
    setTask(job);
  };

  function getActiveAppointmentDate() {
    const storeData = readonly ? tasks.tasks.filter((d) => parseInt(d.ReceiptNo) === parseInt(ReceiptNo)) : loadBaslandiJob();
    axios.get(`/GetActiveAppointmentDate/${ReceiptNo}`)
      .then((response) => {
        if (storeData.length !== 0) {
          storeData[0].AppointmentDate = response.data;
          setData(storeData[0]);
        } else {
          setData({});
        }
      }).catch((error) => {
      });
  }

  return (
    <Card
      className={clsx(classes.root, className)}
    >
      <CardHeader title={t('detail_title')} />
      <Divider />
      <CardContent className={classes.content}>
        <Typography className={classes.title} color="textSecondary">
          {t('Basvuru_Nedeni')}
        </Typography>
        <Typography variant="h6" component="h2" gutterBottom>
          {readonly
            ? data.IssueReason
            : (
              <AppReasonSearch
                setIssue={setIssue}
                value={{
                  Dsc: data.IssueReason || '',
                  Id: data.IssueReasonId || 0,
                } || ''}
                searchParam={search}
                disabled={!isOnline}
              />
            )}
        </Typography>
        <Typography className={classes.title} color="textSecondary">
          {t('Basvuru_Notu')}
        </Typography>
        <Typography variant="h6" component="h2" gutterBottom>
          {data?.WorkOrderComments !== undefined ? data?.WorkOrderComments?.map((item, index) => (
            <div className={classes.wrapper} key={index}>
              <div>
                {t('lblStatusNote')}
                {' '}
                :
                {' '}
                {item.Dsc}
              </div>
              <div>
                {t('Tarih')}
                {' '}
                :
                {' '}
                {item.CreateDate === undefined ? '' : Moment(item.CreateDate).format('DD/MM/YYYY HH:mm')}
              </div>
              <div>
                {t('Yanitlayan')}
                {' '}
                :
                {' '}
                {item?.EmployeeDsc?.length > 0 ? item?.EmployeeDsc : 'Unknown'}
              </div>
              <Divider />
            </div>

          ))
            : ''}
        </Typography>
        <Typography className={classes.title} color="textSecondary">
          {t('lblLastNote')}
        </Typography>
        <Typography variant="h6" component="h2" gutterBottom>
          {data.StatusNote}
        </Typography>
        <Typography className={classes.title} color="textSecondary" gutterBottom>
          {t('Cagri_Tarihi')}
          {' '}
          :
          <font
            variant="h6"
            component="h2"
            style={{ fontWeight: '500', fontFamily: 'Roboto', color: 'black', }}
          >
            {data.OpenDate === undefined ? '' : Moment(data.OpenDate).format('DD/MM/YYYY HH:mm')}
          </font>
        </Typography>
        <Typography className={classes.title} color="textSecondary" gutterBottom>
          {t('Randevu')}
          {' '}
          :
          <font
            variant="h6"
            component="h2"
            style={{ fontWeight: '500', fontFamily: 'Roboto', color: 'black', }}
          >
            {data.AppointmentDate === undefined ? '' : Moment(data.AppointmentDate).format('DD/MM/YYYY HH:mm') || ''}
          </font>
        </Typography>
        <Typography className={classes.title} color="textSecondary">
          {t('CM_Gelis_Marka')}
        </Typography>
        <Typography variant="h6" component="h2" gutterBottom>
          {data.Brand}
        </Typography>
        <Typography className={classes.title} color="textSecondary">
          {t('GelisYeri_MusteriDanismani_Arama')}
        </Typography>
        <Typography variant="h6" component="h2" gutterBottom>
          {data.Channel}
          {' '}
          -
          {data.ConsumerConsultant}
        </Typography>
        <Typography variant="h6" component="h2" gutterBottom>
          <Button
            variant="contained"
            color="primary"
            className={classes.submitButtonFile}
            endIcon={<ListAltIcon />}
            onClick={() => setCompensationPopup(true)}
            disabled={!isOnline}
          >
            {t('lblCompensationForm')}
          </Button>
        </Typography>
        <Typography variant="h6" component="h2" gutterBottom>
          <Button
            variant="contained"
            color="primary"
            className={classes.submitButtonFile}
            endIcon={<AssignmentTurnedInIcon>Onizleme</AssignmentTurnedInIcon>}
            onClick={() => setGdprPopupOpen(true)}
            disabled={!isOnline}
          >
            {t('lblGdpr')}
          </Button>
        </Typography>
        {/* 
        <Typography variant="h6" component="h2" gutterBottom>
          <Button
            variant="contained"
            color="primary"
            className={classes.submitButtonFile}
            endIcon={<NextWeekIcon>Onizleme</NextWeekIcon>}
            onClick={() => setNewWorkCasePopupOpen(true)}
          >
            {t('lblNewWorkCase')}
          </Button>
        </Typography> 
        */}
      </CardContent>
      <Dialog
        open={CompensationPopup}
        onClose={() => setCompensationPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
        fullWidth
      >
        <DialogActions>
          <IconButton
            color="primary"
            onClick={event => setCompensationPopup(false)}
            aria-label="upload picture"
            component="span"
          >
            <CloseIcon />
          </IconButton>
        </DialogActions>
        <DialogContent>
          <Compensation ReceiptNo={ReceiptNo} readonly={false} />
        </DialogContent>
      </Dialog>
      <CCFilePopup
        onClose={handleCCFileClose}
        ReceiptNo={ReceiptNo}
        open={CCFilePopupOpen}
      />
      <GdprPopup
        onClose={handleGdprPopupClose}
        open={GdprPopupOpen}
        ReceiptNo={ReceiptNo}
        ConsumerId={data.CustomerNo}
      />
      {
        data.CustomerNo === undefined ? '' : (
          <NewWorkCasePopup
            onClose={handleNewWorkCasePopupClose}
            open={NewWorkCasePopupOpen}
            ConsumerId={data.CustomerNo}
            ReceiptNo={ReceiptNo}
          />
        )
      }

    </Card>
  );
}
Aciklama.propTypes = {
  className: PropTypes.string,
};


export default connect(
  (state) => ({
    tasks: state.tasks1,
  }),
  { setTask }
)(Aciklama);
